import styled from "styled-components";
import { motion } from "framer-motion";

export const AccordionWrapper = styled.div`
  width: 100%;
  margin: 0.75rem auto;
  border-radius: 0.625rem;
  background: #fff;
  box-shadow: 0 0.25rem 0.625rem rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: box-shadow 0.3s ease;

  &:hover {
    box-shadow: 0 0.375rem 0.875rem rgba(0, 0, 0, 0.15);
  }
`;

export const AccordionHeader = styled.button`
  width: 100%;
  padding: 1.625rem;
  background: #f7f7f7;
  font-size: 1.25rem;
  font-weight: bold;
  border: none;
  text-align: left;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: background 0.3s ease;

  &:hover {
    background: #ececec;
  }
`;

export const AccordionContent = styled(motion.div)`
  background: white;
  font-size: 1.125rem;
  line-height: 1.5;
  padding: 0 1rem;
  overflow: hidden;
`;

export const ArrowIcon = styled(motion.span)`
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.1s ease;
`;
